import classNames from "classnames";

interface NumberedCardProps {
  number?: number;
  text: string;
  className?: string;
}

export const NumberedCard = ({
  number,
  text,
  className,
}: NumberedCardProps) => {
  return (
    <div
      className={classNames(
        "flex gap-4 bg-gradient-to-r from-sendolab-gray4 via-sendolab-gray2 to-sendolab-gray4 px-4 py-1 rounded-lg items-center",
        className,
        {
          "mt-8": number !== undefined,
        }
      )}
    >
      {number && (
        <p className="-mt-6 text-[82px] leading-none font-bold bg-clip-text text-transparent bg-gradient-to-b from-sendolab-gold3 to-sendolab-gray4">
          {number}
        </p>
      )}
      <p className="text-sendolab-white2">{text}</p>
    </div>
  );
};
